'use strict';

// Import Libraries
import React from 'react';
import { builderDispatch } from '../_utils/ui'
import Events              from '../_shelf-category/flux-events';
import Favouritable from './favouritable';

export default class FavouritableWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      favourited: this.props.favourited
    };
  }

  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      switch(payload.type) {
        case Events.FAVOURITED:
          this.handleFavourited(payload.designCode);
          break;
        }
    });
  }

  render() {
    return (
      <Favouritable designCode={this.props.designCode}
                    favourited={this.state.favourited} />
    );
  }

  handleFavourited(designCode) {
    this.setState(state => {
      return { favourited: !state.favourited };
    });
  }
}
